import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DashboardService } from 'src/app/views/Dashboard/Dashboad.service';

@Component({
  selector: 'app-dataupload',
  templateUrl: './dataupload.component.html',
  styleUrls: ['./dataupload.component.css']
})
export class DataUploadComponent implements OnInit {
  file: any;
  formData: any;

  constructor(private service: DashboardService, private toster: ToastrService) { }

  ngOnInit() {
  }
  downloadSample() {
    let link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = '/assets/files/Employee list-Praveen.xlsx';
    link.download = 'EmployeeList.xlsx';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
  downloadCountrySample() {
    let link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = '/assets/files/Employee list-Praveen.xlsx';
    link.download = 'EmployeeList.xlsx';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
  downloadEmployeeStatusSample() {
    let link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = '/assets/files/Employee list-Praveen.xlsx';
    link.download = 'EmployeeList.xlsx';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  onFileSelected(event: any): void {
    this.file = event.target.files[0];
    if (this.file) {
      this.formData = new FormData();
      this.formData.append('file', this.file);
    }
  }
  uploadCompetencyExcelFile(): void {
    this.service.PostBulkUploadOfCompetencies(this.formData).subscribe(x => this.toster.success("Successfully Upload"));
  }
  uploadCountryExcelFile(): void {
    this.service.PostBulkUploadOfCountries(this.formData).subscribe(x => this.toster.success("Successfully Upload"));
  }

  uploadEmployeeExcelFile(): void {
    this.service.PostBulkUploadOfEmployeeStatus(this.formData).subscribe(x => this.toster.success("Successfully Upload"));
  }

  uploadOfEmployees() {
    this.service.GetBulkUploadOfEmployees().subscribe(x => this.toster.success("Successfully Upload"));
  }

}